/**
 * @file 处理 ModalRoute url
 */
import { useCallback } from "react"
import { useHistory, useLocation } from "react-router"

import {
  MODAL_QUERY_NAMESPACE,
  Query,
  RouteParams,
} from "packages/route/types"

import { appendQueryString } from "./utils"

export const encodeModalQuery = (query: Query) =>
  encodeURIComponent(JSON.stringify(query))

export const useDecodeModalQuery = () => {
  const location = useLocation()
  const history = useHistory()

  return useCallback(
    (str: string) => {
      try {
        const modalQuery = JSON.parse(decodeURIComponent(str))
        return modalQuery
      } catch (e) {
        // 替换掉 search，即 modal 相关的任何参数，关闭弹窗
        history.replace(location.pathname)

        // 一般是 url 格式有误，JSON.parse 执行失败
        throw e
      }
    },
    [location, history]
  )
}

export const composeModalUrl = (
  modalName: string,
  query?: RouteParams | null,
  prevSearch = ""
) => {
  let modalQuery = ""
  if (query) {
    modalQuery = encodeModalQuery(query)
  }

  return appendQueryString(prevSearch, {
    modal: modalName,
    [MODAL_QUERY_NAMESPACE]: modalQuery,
  })
}
